import { useEffect, useMemo } from "react";

import useApiRequestPost from "../../components/apiHooks/useApiRequestPost";
import { useConfigActions, useConfigContext } from "../../contexts/ConfigContext/ConfigContext";
import { getStoredFingerprint } from "../../services/fingerprint";
import { ISessionResponse } from "./types";

const HOST: string = process.env.CLOUD_RUN_GATEWAY_HOST ?? "";
const END_POINT: string = process.env.API_SESSION ?? "";

interface IUseGetSessionOptions {
	autoFetch?: boolean;
}

const useGetSession = (options?: IUseGetSessionOptions) => {
	const { autoFetch = true } = options ?? {};
	const fingerprint = getStoredFingerprint();
	const { state: location } = useConfigContext((state) => state.location);
	const actions = useConfigActions();
	const url: string = useMemo(() => {
		if (!location?.id || !fingerprint) return "";

		return `${HOST}${END_POINT}`;
	}, [location?.id, fingerprint]);

	const payload = useMemo(
		() => ({
			url,
			triggerOnMount: autoFetch,
			body: {
				location: location?.id,
				identifier: fingerprint,
			},
			swrConfig: {
				revalidateOnFocus: false,
			},
		}),
		[url, location?.id, fingerprint, autoFetch]
	);

	const {
		data: response,
		isLoading,
		error,
		postData,
	} = useApiRequestPost<ISessionResponse>(payload);

	useEffect(() => {
		if (!response) return;

		actions.SET_SESSION({ session_id: response.token });
	}, [response, actions]);

	return {
		data: response,
		isLoading,
		error,
		postData,
	};
};

export default useGetSession;
